<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug"></template>

<script>
import { mapState } from "vuex";
import wlArticle from "@/components/wl-article";
export default {
  components: {wlArticle},
  data() {
    return {
      expert_id: null,
      info: {},


      RefreshLoading: false, //刷新
      Loading: false,      //加载
      Finished: false,      //加载完成
      List: [],
      pagination:{
        index: 0,
        pages: 0,
        size: 20,
        total: 0,
      },
    };
  },
  computed: {
    ...mapState(['userInfo','authToken','user_title'])
  },
  watch: {
    
  },
  created: function() {
  },
  mounted: function() {
    var expert_id = this.$route.params.expert_id;
    this.expert_id = Number(expert_id);
    //获取专家详情
    this.getExpertInfo();
  },
  methods: {

    //刷新列表
    refreshList() {
      this.Loading = true;
      this.Finished = false;
      this.pagination.index = 0;
      this.List = [];
      this.loadList().then(res=>{
        this.RefreshLoading = false;
      })
    },
    //加载列表
    loadList() {
      // 异步更新数据
      var params = {
        pagination: {
          index: this.pagination.index + 1,
          size: this.pagination.size,
        },
        sort: [{code:"publishDtm",desc:true}],
        condition: {
          stc: "1",
          items: [
            { code: "userId", opc: "=", values: [this.expert_id] },
          ],
        }
      };
      var _this = this;
      return new Promise((resolve,reject)=>{
        _this.$api.articlePage(params).then(res=>{
          var data = res.data;
          var list = data.data || [];
          list.map(r=>{
            if(r.imgs){
              r.imgs = JSON.parse(r.imgs);
            }else{
              r.imgs = [];
            }
            return r;
          })
          if(data.pagination.index===1){
            _this.List = list;
          }else{
            _this.List = _this.List.concat(list);
          }
          _this.pagination = data.pagination;
          // 数据全部加载完成
          if (_this.List.length >= _this.pagination.total) {
            _this.Finished = true;
          }
          // 加载状态结束
          _this.Loading = false;
          resolve();
        });
      })
      
    },

    //获取专家详情
    getExpertInfo(){
      this.$api.userDetail({ id: this.expert_id }).then((res) => {
        if (!res.data) {
          this.$toast("未找到相关专家");
          this.$router.back();
        } else {
          var fo = res.data;
          if(fo.competent){
            fo.competent = JSON.parse(fo.competent);
          }else{
            fo.competent = [];
          }
          this.info = fo;
        }
      });
    },
    //收藏专家
    doCollect(){
      //关注
      this.$toast.loading({
        message: "处理中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      this.$api.userFav({favUserId:this.expert_id}).then(res=>{
        this.$toast.clear();
        this.$wlAlert({type:1,msg: '收藏成功！',tip:'查看我收藏的所有专家'});
        this.getExpertInfo();
      })
      // this.$wlAlert({type:1,msg: '收藏成功！',tip:'查看我收藏的所有专家'});
      // this.$wlAlert({type:1,msg: '您已收藏了这位专家',tip:'查看我收藏的所有专家'});
      // this.$wlAlert({type:2,msg: '信息已提交成功！',tip:'感谢您的反馈建议！'});
      // this.$wlAlert({type:2,msg: '信息已提交成功！',tip:'感谢您的反馈建议！'});
    },
    //取消关注专家
    delCollect(){
      this.$toast.loading({
        message: "处理中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      this.$api.userUnFav({favUserId:this.expert_id}).then(res=>{
        this.$toast.clear();
        this.$wlAlert({type:1,msg: '取消收藏成功！',tip:'查看我收藏的所有专家'});
        this.getExpertInfo();
      })
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/expert/expert_info/index.vue